import { createSelector } from 'reselect'

const signupSelector = state => state.signup
const qsSelector = state => state.qs
const uiSelector = state => state.ui

export default createSelector(
	[signupSelector, qsSelector, uiSelector],
	(signupSelectorData, qsSelectorData, uiSelectorData) => ({
		signup: signupSelectorData,
		isInIframe: uiSelectorData.isInIframe,
		canActAsStudent: qsSelectorData.from_google_slides !== '1',
	})
)
